var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReminderAnticlockwise = function SvgReminderAnticlockwise(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3F46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.226 3.078a12.5 12.5 0 0 0-.407 3.2c0 .282.237.373.466.424h.002m3.05.29a12.5 12.5 0 0 1-3.05-.29m0 0a6.667 6.667 0 1 1-.883 4.923m8.263.875-1.422-1.423a.833.833 0 0 1-.245-.589V7.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReminderAnticlockwise);
export default ForwardRef;